import { Poppins, Quicksand } from 'next/font/google';
import Link from 'next/link';
import React, { Component } from 'react'
const popins = Poppins({weight:['500','600','700'],subsets:['latin'],display:'swap',preload:true});
const quickSand = Quicksand({weight:['400','500','600'],subsets:['latin'],display:'swap',preload:true});

export class Chennaiotherlocation extends Component {
  render() {
    const othercourse =[
      {
        id:1,
        path:`../bangalore/${this.props.url}-training-in-bangalore`,
        location:`Bangalore`,
      },
      {
        id:2,
        path:`../hyderabad/${this.props.url}-training-in-hyderabad`,
        location:`Hyderabad`,
      },
      {
        id:3,
        path:`../kolkata/${this.props.url}-training-in-kolkata`,
        location:`Kolkata`,
      },
      {
        id:4,
        path:`../trivandrum/${this.props.url}-training-in-trivandrum`,
        location:`Trivandrum`,
      },
      {
        id:5,
        path:`../coimbatore/${this.props.url}-training-in-coimbatore`,
        location:`Coimbatore`,
      },
      {
        id:6,
        path:`../kochi/${this.props.url}-training-in-kochi`,
        location:`Kochi`,
      },
      {
        id:7,
        path:`../mumbai/${this.props.url}-training-in-mumbai`,
        location:`Mumbai`,
      },
      {
        id:8,
        path:`../delhi/${this.props.url}-training-in-delhi`,
        location:`Delhi`,
      },
      {
        id:9,
         path:`../gurgaon/${this.props.url}-training-in-gurgaon`,
        location:`Gurgaon`,
      },
      {
        id:10,
        path:`../pune/${this.props.url}-training-in-pune`,
        location:`Pune`,
      },
    ]

    return (
      <>
        {/* <section className='bgc-lr pdtb30 mpdt0'>
          <div className='container'>
            <h3 >{this.props.title} Training in Other Location</h3>
            <div className='df fw mfdc '>
            {othercourse.map((othercourse, i) => {
              return (
                <a href={othercourse.path}>
                  <div className='pd5'>
                    <div key={i}>
                      <div className='box'>
                        <h4 className='df pd5'>{othercourse.location}</h4>
                      </div>
                    </div>
                  </div>
                </a>
              )
            })}
            </div>
          </div>
          <style jsx>
            {`
             .box{
              border:1px solid #000;
              border-radius:5px;
             }
            `}
          </style>
        </section> */}
        <section className={`container`}>
    <div className={`whole-pdtb`}>
    <h4 className={`fs-30 tfs-28 mfs-21 fwb600  ${popins.className}`}> {this.props.title} Online   <span className={`ylw-clr ${popins.className}`}> Training Options in Other Locations </span> </h4>
    <p className={`fs-16 mfs-15 fwb500 mt32 tmt28 mmt24 ${quickSand.className}`}>To cater to the diverse learning needs of individuals across different regions, we bring our high-quality training services to your preferred location. Select your city below to maximize the value of your training investment</p>
     <div className={`df  gap11 fw mt22 tmt20 mmt16`}>
     {othercourse.map((othercourse) => (
    <Link  href={othercourse.path} key={othercourse.id}> 
    <div className={`other-location-btn`} >
        <p className={`fs-16 mfs-15 ${popins.className}`}>{othercourse.location}</p>
     </div>
     </Link>
     ))}
     </div>
    </div>
</section>
      </>
    )
  }
}

export default Chennaiotherlocation